import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const ExcelDownloadContainer = styled.div`
    padding-right: 40px;
    padding-left: 10px;
`;

export const TableContainer = styled.div`
    .swTable-cell {
        border-bottom: 1px solid ${carbon[50]};
    }
`;

export const SiteTabsContainer = styled.div`
    padding: 0px 12px 16px 12px;
    width: 100%;
    display: flex;
`;

export const MainDomain = styled.span`
    align-self: center;
    width: 120px;
    color: ${carbon[400]};
    ${setFont({ $size: 14, $weight: 400 })};
`;
